import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md rounded-2xl shadow-md border border-gray-200 bg-white p-8">
        <Outlet />
      </div>
    </div>
  );
}
